import { Status } from "../../types/common";
import React from "react";

export interface LoaderContextType {
  setLoaderStatus: (_: Status[]) => void;
  isLoading: boolean;
}

export const LoaderContext = React.createContext<LoaderContextType>(null!);
